import React, { Suspense, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Sidebar from "../../component/SideBar";
import MobileSidebar from "../../component/SideBar/mobileView";
import ProtectedRoute from "../../otherRoutes/ProtectedRoute";
import AdminRoutes from "../../routes/adminRoutes";
import UserRoutes from "../../routes/userRoutes";
import WareHouseRoutes from "../../routes/wareHouseRoutes";
import useWindowSize from "../../hooks/useWindowSize";

const MainLayout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [userType, setUserType] = useState("user"); // default "user"
  const [userId, setUserId] = useState(null);
  const isMobileView = useWindowSize();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded.role ? decoded.role.toString().trim().toLowerCase() : "user";
        setUserType(role);
        setUserId(decoded.id || null);

        // console.log("Decoded Role:", role);
        // console.log("User ID:", decoded.id);
      } catch (error) {
        console.error("Failed to decode token:", error);
        setUserType("user");
        setUserId(null);
      }
    } else {
      setUserType("user");
      setUserId(null);
    }
  }, []);

  const renderRoutes = () => {
    if (userType === "admin") return <AdminRoutes />;
    if (userType === "warehouse") return <WareHouseRoutes />;
    return <UserRoutes />; // default
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      {isMobileView ? (
        <MobileSidebar />
      ) : (
        <div
          className={`transition-all duration-300 ease-in-out bg-white shadow h-full ${
            isOpen ? "w-64" : "w-20"
          }`}
        >
          <Sidebar
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            userType={userType}
            userId={userId}
          />
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto bg-primaryLight p-4">
        <main className="min-h-screen">
          <ProtectedRoute>
            <Suspense fallback={<div>Loading...</div>}>
              {renderRoutes()}
            </Suspense>
          </ProtectedRoute>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
